'use client';
import Link from 'next/link';
import styled from 'styled-components';

export const StyledFloatingCtaContainer = styled.div`
  z-index: 50;
  display: flex;
  justify-content: center;
  position: sticky;
  top: ${({ theme }) => theme.spacing(0)};
  @media ${({ theme }) => theme.laptop} {
    display: ${props => (props.$mobileOnly ? `none` : `contents`)};
  }
`;

export const StyledFloatingCtaButton = styled(Link)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: none;
  background-color: ${({ theme }) => theme.colors.secondary.sea};
  border-radius: 100px;
  width: 300px;
  margin: ${({ theme }) => theme.spacing(2, 0)};
  padding: ${({ theme }) => theme.spacing(3)};
  filter: drop-shadow(0px 4px 12px #00000040);
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const TextContainer = styled.p`
  ${({ theme }) => theme.typography.bodyBold};
  color: ${({ theme }) => theme.colors.text.lightest};
  text-align: center;
  leading-trim: both;
  text-edge: cap;
  font-size: 20px;
  font-style: normal;
  line-height: 24px; /* 120% */
  letter-spacing: 0.2px;
`;

export const CloseButtonContianer = styled.button`
  background: none;
  border: 0;
  padding: 0px;
  display: flex;
  align-items: center;
`;
